module.exports = __webpack_public_path__ + "static/media/20_4.d9a56d94.png";